/* global axios */
import ApiClient from './ApiClient';

class TalkviaPixChargesAPI extends ApiClient {
  constructor() {
    super('talkvia_pix_charges', { accountScoped: true });
  }

  availability() {
    return axios.get(`${this.url}/availability`);
  }

  createCharge(params) {
    return axios.post(this.url, params);
  }
}

export default new TalkviaPixChargesAPI();
